angular.module('nv.SchoolMetricsModule').component('gradPlanningMetrics', {
  template: require('./grad-planning-metrics.html'),
  bindings: {
    currentSchool: '<',
  },
  controller: 'GradPlanningMetricsCtrl',
});
